import { Component, OnInit } from '@angular/core';
import { jwtDecode } from "jwt-decode";
import { JsonService } from './_services/json.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subscription, firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';
import { AuthenticationService } from './_services/authentication.service';
import { LoaderComponent } from './loader/loader.component';
import { LoadingService } from './_services/loading.service';
import { filter } from 'rxjs/operators';
import { GlobalService } from './_services/global.service';
import { LoggerService } from './_services/logger.service';
import { User } from './_models/user.model';
import { IndexedDbService } from './_services/indexed-db.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'front-end';
  public getRemedios: any = [];
  public listaMedicos: any[] = [];;
  public listaCRM: Array<any> = [];
  public listaEndereco: Array<any> = [];
  private routerSubscription!: Subscription;
  mostrarDialog: boolean = false;
  public showHeader: boolean = true;
  public showSidebar: boolean = false;
  public sidebarExpanded: boolean = false;

  code: string | null = null;
  code_verifier: string = '';
  refresh_token: string = '';
  id_token: string = '';

  
  user: User | null = null;
  private subscription: Subscription = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private jsonService: JsonService,
    private LoaderComponent: LoaderComponent,
    private router: Router,
    private logger: LoggerService,
    private loadingService: LoadingService,
    private authService: AuthenticationService,
    public global: GlobalService,
    private db: IndexedDbService
  ) {
    this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          // Esconde o header se a URL for exatamente '/image'
          this.showHeader = event.urlAfterRedirects !== '/image';
          const hideSidebarRoutes = ['/image', '/login', '/auth-callback', '/tooltip'];
          this.showSidebar = !hideSidebarRoutes.some(p => event.urlAfterRedirects.startsWith(p));
        });
  }

  chamarApiAoSair(){
    
    if(localStorage.getItem('unlockid')){
      this.jsonService.unlockPage(localStorage.getItem('unlockid')).subscribe(
        resp => {
          localStorage.removeItem('unlockid');
        },
        erro => {
          this.logger.error('Erro ao chamar unlockPage', erro);
        }
      );
    }
      
  }
  
  ngOnInit(): void {
    this.subscription.add(
      this.authService.user$.subscribe(user => {
        this.user = user;
      })
    );

    this.checkTokenOnResume();

    // Verifica token ao retornar para a aba
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.checkTokenOnResume();
      }
    });

    // Escuta logout de outras abas
    window.addEventListener('storage', (e: StorageEvent) => {
      if (e.key === 'logout_broadcast' && e.newValue === 'true') {
        this.authService.logout();
      }
    });

    this.chamarApiAoSair();
    this.loadArrays();
  }

  private async checkTokenOnResume(): Promise<void> {
    const token = await this.db.getData('access_token');
    if (!token) return;
    try {
      const decoded: any = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
      if (decoded.exp && decoded.exp < now) {
        await firstValueFrom(this.authService.refreshTokenRequest()).catch(() => {
          this.authService.logout();
        });
      }
    } catch {
      this.authService.logout();
    }
  }

  setCookie(name: string, value: string) {
    this.jsonService.cookieCreate(name, value).subscribe(
      resp => {
        console.log('Cookie criado com sucesso:', resp);
        this.readCookie('exampleCookie');
      },
      erro => {
        this.logger.error('Erro ao criar cookie', erro);
      }
    );
  }

  readCookie(name: string) {
    this.jsonService.cookieGet(name).subscribe(
      resp => {
        console.log('Cookie lido com sucesso:', resp);
      },
      erro => {
        this.logger.error('Erro ao ler cookie', erro);
      }
    );
  }

  logout(): void {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  loadArrays() {
    if(this.db.getData('id_token')) {
      this.jsonService.setUserRegister().subscribe(
        resp => {
          //
        },
        erro => {
          this.logger.error('Erro ao registrar usuário', erro);
        }
      );
      
      this.jsonService.getUserPermission().subscribe(
        resp => {
          this.global.setPermissions(resp);
          this.global.isAdmin();
        },
        erro => {
          this.logger.error('Erro ao carregar permissões do usuário', erro);
        }
      );
      // this.jsonService.getMedicins().subscribe(
      //   resp => {
      //     let remedios = resp.map((item: string) => item.toLowerCase());
      //     this.global.listaProdutos = remedios;
      //   },
      //   erro => {
      //     this.logger.error('Erro ao carregar produtos', erro);
      //   }
      // );
      
      // this.jsonService.getEspecialidade().subscribe(
      //   resp => {
      //     let remedios = resp.map((item: string) => item.toLowerCase());
      //     this.global.listaEspecialidade = remedios;
      //   },
      //   erro => {
      //     this.logger.error('Erro ao carregar especialidades', erro);
      //   }
      // );
      
      // this.jsonService.getPosologia().subscribe(
      //   resp => {
      //     let remedios = resp.map((item: string) => item.toLowerCase());
      //     this.global.listaPosologia = remedios;
      //   },
      //   erro => {
      //     this.logger.error('Erro ao carregar posologia', erro);
      //   }
      // );
      
      // this.jsonService.getMedico().subscribe(
      //   resp => {
      //     this.listaMedicos = resp.map(item => 
      //       typeof item === 'string' ? item.toLowerCase() : item
      //     );
      //     this.global.listaNomeMedico = this.listaMedicos;
      //   },
      //   erro => {
      //     this.logger.error('Erro ao carregar nomes de médicos', erro);
      //   }
      // );
      
      // this.jsonService.getCRM().subscribe(
      //   resp => {
      //     let crms = resp.map(item => 
      //       typeof item === 'string' ? item.toLowerCase() : item
      //     );
      //     this.global.listaCRM = crms;
      //   },
      //   erro => {
      //     this.logger.error('Erro ao carregar CRMs', erro);
      //   }
      // );
      
      // this.jsonService.getEndereco().subscribe(
      //   resp => {
      //     let enderecos = resp.map(item => 
      //       typeof item === 'string' ? item.toLowerCase() : item
      //     );
      //     this.global.listaEndereco = enderecos;
      //   },
      //   erro => {
      //     this.logger.error('Erro ao carregar endereços', erro);
      //   }
      // );
    }
  }

  abrirDialog() {
    this.mostrarDialog = true;
  }

  fecharDialog() {
    this.mostrarDialog = false;
  }

  onSidebarExpanded(expanded: boolean): void {
    this.sidebarExpanded = expanded;
  }
}
